import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const width = useSpring(scrollYProgress, {
    stiffness: 220,
    damping: 40,
    restDelta: 0.001
  });
  return <motion.div aria-hidden="true" style={{
    scaleX: width
  }} className="fixed left-0 top-0 z-[60] h-[3px] w-full origin-left bg-lilac" data-id="element-47" data-mp="kwmj50n4sto" />;
}